import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { FiEdit } from "react-icons/fi";
import { IoIosAddCircle } from "react-icons/io";
import Model from "../../../component/Model/Model";
import {
  // useDeleteRecordMutation,
  useCreateMutation,
  useUpdateMutation,
  useGetVehicleColorQuery,
} from "../../../store/api/configurationSlice";
import { Modal } from "react-bootstrap";
import { IoCloseSharp } from "react-icons/io5";
import SkeletonLoading from "../../../component/SkeletonLoading";
import CreateModal from "../../../component/Model/CreateModel";
import AdminPagination from "../../../component/pagination/AdminPagination";
import { useTranslation } from "react-i18next";
import i18n from "../../../store/api/i18n";

const initialState = {
  name: "",
};

const Color = () => {
  const { t } = useTranslation();
  // const [show, setShow] = useState(false);
  // const [id, setId] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [editData, setEditData] = useState(null);
  const [color, setColor] = useState([]);
  const [show2, setShow2] = useState(false);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    search: "",
  });

  // Fetch data
  const { data, isLoading, isFetching, isSuccess, refetch } =
    useGetVehicleColorQuery({
      page: pagination.page,
      limit: pagination.limit,
      search: pagination.search,
    });

  // Delete Data
  // const [deleteVehicleColor, { isLoading: isDeleting }] =
  //   useDeleteRecordMutation("vehicle-color");

  // Create Name
  const [create, { isLoading: isAddLoading }] = useCreateMutation();

  // Update Name
  const [update, { isLoading: isUpdateLoading }] = useUpdateMutation();

  // When data is fetched, update the filtered data
  useEffect(() => {
    if (isSuccess && data?.data) {
      setColor(data?.data?.colors);
      setPagination((prev) => ({
        ...prev,
        total: data.data.pagination.total,
        page: data.data.pagination.page,
        limit: data.data.pagination.limit,
        totalPages: data.data.pagination.pages,
      }));
    }
  }, [data, isSuccess]);

  // const handleShow = (id) => {
  //   setShow(true);
  //   setId(id);
  // };

  // show edit model
  const handleEdit = ({ name, id }) => {
    setEditData(null);
    setEditData({ name, id });
    setShowModel(true);
  };

  // Delete Vehicle Make
  // const handleDelete = async () => {
  //   try {
  //     const response = await deleteVehicleColor({
  //       id,
  //       endPoint: "vehicle-color",
  //     }).unwrap();
  //     if (response.statusCode === 200) {
  //       toast.success(response.message);
  //       setShow(false);
  //       setId("");
  //     }
  //   } catch (err) {
  //     const mesg = err.data?.message || "Something went wrong";
  //     toast.error(mesg);
  //   }
  // };

  const handleClose = () => {
    setShow2(false);
    setEditData(null);
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  const handleSearch = () => {
    setPagination((prev) => ({
      ...prev,
      page: 1,
      search: search.trim(),
    }));
  };

  useEffect(() => {
    if (!search.trim()) {
      setPagination((prev) => ({
        ...prev,
        search: "",
      }));
    }
  }, [search]);

  const handleClose2 = () => {
    setShowModel(false);
  };

  // Language Change Handler
  useEffect(() => {
    const h = () => {
      refetch?.();
    };
    i18n.on("languageChanged", h);
    return () => i18n.off("languageChanged", h);
  }, [refetch]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap w-100 mb-2">
        <div className="total">
          {t("total")}: {pagination.total}
        </div>

        <div className="d-flex flex-wrap gap-2">
          <div className="d-flex flex-grow-1">
            <input
              type="text"
              className="form-control custom-field-one"
              placeholder={`${t("search")} ${t("by")} ${t("vehicle")} ${t(
                "color",
              )}`}
              value={search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="d-flex gap-2 flex-grow-1">
            <button
              className="btn btn-primary flex-grow-1"
              onClick={handleSearch}
            >
              {t("search")}
            </button>
            <Button
              className="d-flex align-items-center gap-1 flex-grow-1 justify-content-center"
              onClick={() => setShowModel(true)}
            >
              <IoIosAddCircle size={15} fill="white" />
              {t("add")}
            </Button>
          </div>{" "}
        </div>
      </div>

      <Model
        show={showModel}
        onHide={handleClose2}
        initialState={initialState}
        editData={editData}
        title={
          editData
            ? `${t("update")} ${t("vehicle")} ${t("color")}`
            : `${t("add")} ${t("vehicle")} ${t("color")}`
        }
        submit={editData ? update : create}
        EndPoint="vehicle-color"
        loading={isAddLoading || isUpdateLoading}
        onSuccess={() => setShow2(true)}
      />

      <div className="table m-0">
        <table>
          <thead>
            <tr>
              <th>
                {t("SR")}.{t("no")}.
              </th>
              <th>
                {t("vehicle")} {t("color")}
              </th>
              <th width="70px">{t("action")}</th>
            </tr>
          </thead>
          <tbody>
            {isLoading || isFetching ? (
              <SkeletonLoading length={3} />
            ) : color.length > 0 ? (
              color.map((item, i) => (
                <tr key={i}>
                  <td>{(pagination.page - 1) * pagination.limit + i + 1}</td>
                  <td>{item.name}</td>
                  <td>
                    <div className="actionBtn d-flex">
                      <Button
                        title={t("edit")}
                        className="rounded-circle me-2"
                        onClick={() => handleEdit(item)}
                      >
                        <FiEdit />
                      </Button>
                      {/* <Button
                              title="Delete"
                              className="rounded-circle"
                              onClick={() => handleShow(item.id)}
                            >
                              <RiDeleteBin6Fill />
                            </Button> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="12">
                  <div>
                    <span>
                      {t("no")} {t("vehicle")} {t("color")} {t("found")}
                    </span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      {/* Delete Confirmation Modal */}
      {/* <Modal show={show}>
          <Button className="closePopup" onClick={() => setShow(false)}>
            <IoCloseSharp />
          </Button>
          <div className="popupBox p-3 p-md-5">
            <div>
              <div className="text-center mb-3 errorIcon">
                <BiSolidError />
              </div>
              <div className="text-center mb-4 deleteHd">
                Are you sure you want to delete?
              </div>
              <div className="text-center">
                <Button
                  className="smallBtn cancel me-3"
                  onClick={() => setShow(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="smallBtn auto"
                  onClick={handleDelete}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only p-0"></span>
                    </div>
                  ) : (
                    "Delete"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Modal> */}

      <Modal show={show2}>
        <Button className="closePopup" onClick={handleClose}>
          <IoCloseSharp />
        </Button>
        <CreateModal
          title={`${t("vehicle")} ${t("color")} ${
            editData ? t("updated") : t("added")
          } ${t("successfully")}!`}
          text={`${
            editData
              ? `${t("vehicle")} ${t("color")} ${t("has")} ${t("been")} ${t(
                  "updated",
                )}.`
              : `${t("vehicle")} ${t("color")} ${t("has")} ${t("been")} ${t(
                  "added",
                )}.`
          }`}
          onClose={handleClose}
        />
      </Modal>
    </>
  );
};

export default Color;
